import { render, staticRenderFns } from "./Storyblok.vue?vue&type=template&id=b69530e0&"
import script from "./Storyblok.vue?vue&type=script&lang=ts&"
export * from "./Storyblok.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports